import { types } from '../../types';

const setGetListGameFreespinAction = (payload) => {
  return {
    type: types.freespin.SET_LIST_GAME_FREESPIN,
    payload,
  }
}

const setGetViewGameFreespinAction = (payload) => {
  return {
    type: types.freespin.SET_VIEW_GAME_FREESPIN,
    payload
  }
}

export {
  setGetListGameFreespinAction as SetGetListGameFreespinAction,
  setGetViewGameFreespinAction as SetGetViewGameFreespinAction
}
